import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

interface PhoneNumberProps {
  $mt?: string | number;
}

interface NumberInfoListProps {
  $marginBottom: number;
}

interface InfoTextProps {
  $isHighlighted?: boolean;
  $blurred?: boolean;
}

export const PhoneNumber = styled.h2<PhoneNumberProps>`
  font-weight: 750;
  font-size: 24px;
  line-height: 24px;
  color: rgba(50, 50, 50, 1);
  text-align: center;
  direction: ltr;
  margin-top: ${({ $mt }) => ($mt ? `${+$mt}${typeof $mt === 'number' ? 'px' : ''}` : '16px')};

  ${darkMode(css`
    color: ${darkPalette.textPrimary};
  `)}
`;

export const NumberText = styled.p`
  margin-top: 10px;
  font-weight: 750;
  font-size: 20px;
  line-height: 29px;
  color: rgba(50, 50, 50, 1);

  ${darkMode(css`
    color: ${darkPalette.textPrimary};
  `)}
`;

export const NumberInfoList = styled.ul<NumberInfoListProps>`
  list-style: none;
  margin: 16px 0 ${({ $marginBottom }) => `${$marginBottom}px`};
  display: flex;
  width: 100%;
  flex-direction: column;

  li {
    display: flex;

    &::before {
      content: '';
      border-bottom: 2px dotted rgba(220, 220, 220, 1);
      order: 1;
      flex: 1;
      margin: 0 4px 8px;
    }

    & > span {
      &:last-of-type {
        order: 2;
      }
    }
  }

  ${darkMode(css`
    li::before {
      border-bottom-color: ${darkPalette.border};
    }
  `)}
`;

export const InfoText = styled.span<InfoTextProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: 29px;
  color: rgba(50, 50, 50, 1);
  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      color: #1f7ace;
      font-weight: 750;
    `}
  ${({ $blurred }) =>
    $blurred &&
    css`
      filter: blur(5px);
    `}
  ${darkMode(css`
    color: ${darkPalette.textPrimary};
  `)}
  ${({ $isHighlighted }) =>
    $isHighlighted &&
    darkMode(css`
      color: ${darkPalette.accent};
    `)}
`;

export const ExtraText = styled.span`
  font-weight: 750;
  font-size: 14px;
  line-height: 18px;
  color: rgba(50, 50, 50, 1);
`;

export const ModalHint = styled.span`
  margin-top: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(50, 50, 50, 1);
`;
